import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ToastMessageHandler = (msg, type) => {
  switch (type) {
    case "success": {
      toast.success(msg);
      break;
    }
    case "warn": {
      toast.warn(msg);
      break;
    }
    case "error": {
      toast.error(msg);

      break;
    }
    case "info": {
      toast.info(msg);
      break;
    }
    default: {
      toast.info(msg);
      break;
    }
  }
};

export default ToastMessageHandler;
